import { addresses } from '@/constants/addresses';
import { EthNetwork, EthNetworks } from '@/constants/network';
const chainId = EthNetworks[EthNetwork];

const types = {
  EIP712Domain: [
    { name: 'name', type: 'string' },
    { name: 'version', type: 'string' },
    { name: 'chainId', type: 'uint256' },
    { name: 'verifyingContract', type: 'address' },
  ],
  Bid: [
    { name: 'askHash', type: 'bytes32' },
    { name: 'signer', type: 'address' },
    { name: 'price', type: 'uint256' },
  ],
};

const domain = {
  name: 'AniftyMarketplace',
  version: '1',
  chainId: chainId,
  verifyingContract: addresses.AniftyMarketplaceV3.toLowerCase(),
};

const createParams = (
  askHash: string,
  signer: string,
  price: string
  // eslint-disable-next-line @typescript-eslint/ban-types
): object => {
  const msgParams = {
    types: types,
    primaryType: 'Bid',
    domain: domain,
    message: {
      askHash: askHash,
      signer: signer,
      price: price,
    },
  };

  return msgParams;
};

export default createParams;
